@if (actions()?.length) {
  <div
    class="flex flex-wrap items-center absolute left-1/2 sm:left-30 bottom-0 -translate-x-1/2 z-10  shadow-md bg-(--al-color-palette-dpblue900)! rounded-[4rem]! text-white!">
    <div class="flex gap-1">
      @if (actionMap()?.has(FlowActionPanelAction.ZOOM_IN)) {
        <button mat-icon-button (click)="processAction.emit(FlowActionPanelAction.ZOOM_IN)">
          <mat-icon>add</mat-icon>
        </button>
      }
      @if (actionMap()?.has(FlowActionPanelAction.ZOOM_OUT)) {
        <button mat-icon-button (click)="processAction.emit(FlowActionPanelAction.ZOOM_OUT)">
          <mat-icon>remove</mat-icon>
        </button>
      }
      @if (actionMap()?.has(FlowActionPanelAction.FIT_TO_SCREEN)) {
        <button mat-icon-button (click)="processAction.emit(FlowActionPanelAction.FIT_TO_SCREEN)"
                matTooltip="Fit to Screen">
          <mat-icon>fullscreen</mat-icon>
        </button>
      }
      @if (actionMap()?.has(FlowActionPanelAction.ONE_TO_ONE)) {
        <button mat-icon-button (click)="processAction.emit(FlowActionPanelAction.ONE_TO_ONE)" matTooltip="1:1">
          <mat-icon>filter_1</mat-icon>
        </button>
      }
      @if (actionMap()?.has(FlowActionPanelAction.SELECT_ALL)) {
        <button mat-icon-button (click)="processAction.emit(FlowActionPanelAction.SELECT_ALL)">
          <mat-icon>select_all</mat-icon>
        </button>
      }
      @if (actionMap()?.has(FlowActionPanelAction.DESELECT_ALL)) {
        <button mat-icon-button (click)="processAction.emit(FlowActionPanelAction.DESELECT_ALL)">
          <mat-icon>deselect</mat-icon>
        </button>
      }
      @if (actionMap()?.has(FlowActionPanelAction.RESET_POSITIONS)) {
        <button mat-icon-button (click)="processAction.emit(FlowActionPanelAction.RESET_POSITIONS)">
          <mat-icon>center_focus_weak</mat-icon>
        </button>
      }
    </div>

    @if (actionMap()?.has(FlowActionPanelAction.UNDO) || actionMap()?.has(FlowActionPanelAction.REDO) || actionMap()?.has(FlowActionPanelAction.REMOVE_NODE)) {
      <div class="w-px h-6 bg-gray-300 mx-1"></div>
    }

    <div class="flex gap-1">
      @if (actionMap()?.has(FlowActionPanelAction.UNDO)) {
        <button mat-icon-button [disabled]="!state.canUndo()" (click)="state.undo()">
          <mat-icon>undo</mat-icon>
        </button>
      }
      @if (actionMap()?.has(FlowActionPanelAction.REDO)) {
        <button mat-icon-button [disabled]="!state.canRedo()" (click)="state.redo()">
          <mat-icon>redo</mat-icon>
        </button>
      }
      @if (actionMap()?.has(FlowActionPanelAction.REMOVE_NODE)) {
        <button mat-icon-button [disabled]="!canRemove()" (click)="removeSelected()">
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>

    @if (actionMap()?.has(FlowActionPanelAction.RESET_FLOW)) {
      <div class="w-px h-6 bg-gray-300 mx-1"></div>

      <div class="flex gap-1">

        <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="More Actions">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="reset()">
            <mat-icon>restart_alt</mat-icon>
            <span>{{ 'I18N_FLOW.RESET_FLOW' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    }

  </div>
}
